module.exports = __webpack_public_path__ + "static/media/eu.ff9546c2.svg";